import React from "react"
import { Row, Col, Typography } from "antd"
import styled from "styled-components"

import Candidates from "../../images/landing/stock-image-1.jpg"
import Filtering from "../../images/landing/stock-image-2.jpg"

const { Title } = Typography

const StyledLink = styled.a`
	font-size: 18px !important;
	font-weight: bold;
`

const StyledTitle: typeof Title = styled(Title)`
	margin-top: 20px;
`

const Features: React.FC = () => {
	return (
		<div className={"mt-100 mb-100"} style={{ padding: 20 }}>
			<Row justify={"space-between"}>
				<Col sm={{ span: 24 }} md={{ span: 10, order: 2 }}>
					<img src={Candidates} style={{ width: "100%" }} />
				</Col>

				<Col sm={{ span: 24 }} md={{ span: 11 }}>
					<StyledTitle level={1}>Get Candidates</StyledTitle>
					<p>
						With over <strong>50,0000</strong> jobseekers on our
						platform, we deliver a significant number of fresh,
						quality candidates within 24 hours.
					</p>
					<StyledLink href="/login">Post a job now</StyledLink>
				</Col>
			</Row>

			<Row justify={"space-between"} className={"mt-100"}>
				<Col sm={{ span: 24 }} md={{ span: 10 }}>
					<img src={Filtering} style={{ width: "100%" }} />
				</Col>

				<Col sm={{ span: 24 }} md={{ span: 11 }}>
					<StyledTitle level={1}>Review, Select, Hire</StyledTitle>
					<p>
						With our platform, you can{" "}
						<strong>
							manage all your candidates all in one area
						</strong>
						.
					</p>
					<span>Deep dive into candidates by:</span>
					<ul>
						<li>Auto Filter</li>
						<li>Mass emails or sms</li>
						<li>Follow up questioning</li>
						<li>Making notes about them</li>
					</ul>
					<StyledLink href="/login">
						Find your perfect hire
					</StyledLink>
				</Col>
			</Row>
		</div>
	)
}

export default Features
